import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCalendar, MatCalendarCellClassFunction, MatCalendarCellCssClasses } from '@angular/material/datepicker';

@Component({
  selector: 'app-schedular',
  templateUrl: './schedular.component.html',
  styleUrls: ['./schedular.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SchedularComponent implements OnInit {
  @ViewChild('calendar', { static: false }) calendar: MatCalendar<Date>;
  token: any;

  yesterday = new Date();
  cronType: any = "";
  minuteValue: any = "";
  hourValue: any = "";
  dayValue: any = "";
  dateTypes = 1;
  hourTypes = 1;
  monthValue: any = "";
  dayOfMonthValue: any = "";
  cronTypes = [{ "id": 0, "value": "Choose Preset" }, { "id": 1, "value": "Minute" }, { "id": 2, "value": "Hours" }, { "id": 3, "value": "Range" }, { "id": 4, "value": "Day" }, { "id": 5, "value": "Weekly" }, { "id": 6, "value": "Monthly" }, { "id": 7, "value": "Six(6) Month" }, { "id": 8, "value": "Yearly" }, { "id": 9, "value": "At Hours" }, { "id": 10, "value": "At Mins" }, { "id": 11, "value": "Value list separator" }];
  minuteValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
  hourValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  dateType = [{ "id": 1, "value": "Date" }, { "id": 2, "value": "Date Range" }];
  hourType = [{ "id": 1, "value": "Hour" }, { "id": 2, "value": "Hours Range" }];
  _DateValue = this.dateType[0].id;
  _hourValue = this.hourType[0].id;
  monthValues = [{ "id": 1, "value": "January" }, { "id": 2, "value": "February" }, { "id": 3, "value": "March" }, { "id": 4, "value": "April" }, { "id": 5, "value": "May" }, { "id": 6, "value": "June" }, { "id": 7, "value": "July" }, { "id": 8, "value": "August" }, { "id": 9, "value": "September" }, { "id": 10, "value": "October" }, { "id": 11, "value": "November" }, { "id": 12, "value": "December" }];
  monthID = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  dayOfMonthValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  dayValues = [{ "id": 0, "value": "Choose Day" }, { "id": 1, "value": "Sunday" }, { "id": 2, "value": "Monday" }, { "id": 3, "value": "Tuesday" }, { "id": 4, "value": "Wednesday" }, { "id": 5, "value": "Thrusday" }, { "id": 6, "value": "Friday" }, { "id": 7, "value": "Saturday" }, { "id": "1-5", "value": "Weekdays Only" }, { "id": "5,6", "value": "Weekends(Friday & Saturday" }, { "id": "6,0", "value": "Weekends(Saturday & Sunday)" }];
  dayValueForHr = [{ "id": 0, "value": "Choose Day" }, { "id": 1, "value": "Sunday" }, { "id": 2, "value": "Monday" }, { "id": 3, "value": "Tuesday" }, { "id": 4, "value": "Wednesday" }, { "id": 5, "value": "Thrusday" }, { "id": 6, "value": "Friday" }, { "id": 7, "value": "Saturday" }];
  weekdays = ["1", "2", "3", "4", "5", "6", "7"];
  monthIds = ["1", "2", "3", "4", "5", "6"];
  monthIds1 = ["7", "8", "9", "10", "11", "12"];
  selected = new Date();// | null;
  selectedDayIdList: any[] = [];
  selectedMonthIdList: any[] = [];
  selectedDays = 1;
  selectedMonthId = 1;
  selected1: any;
  datesToHighlight = [];
  schedule: any;
  monmentArray;
  isDisabled:boolean=false;
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    const validDate = new Date(cellDate)
    if (view === 'month') {
      const day = validDate.getDay();
      const month = validDate.getMonth();
      const date = validDate.getDate();
      if (this.weekSelected) {
        if (day === (this.dayValue - 1)) {
          let highDate = validDate.toString().split("GMT")[0];
          this.datesToHighlight.push(highDate);
          // this.selected = null;
          return (day === (this.dayValue - 1)) ? 'example-custom-date-class' : '';
        } else if (this.dayValue == "1-5") {
          let highDate = validDate.toString().split("GMT")[0];
          if ((this.yesterday.getDate() < date) && (day !== 0 && day !== 6)) {
            this.datesToHighlight.push(highDate);
          }
          return day !== 0 && day !== 6 ? 'example-custom-date-class' : '';
        } else if (this.dayValue == "6,0") {
          let highDate = validDate.toString().split("GMT")[0];
          if ((this.yesterday.getDate() < date) && (day !== 1 && day !== 2 && day !== 3 && day !== 4 && day !== 5)) {
            this.datesToHighlight.push(highDate);
          }
          return day !== 1 && day !== 2 && day !== 3 && day !== 4 && day !== 5 ? 'example-custom-date-class' : '';
        } else if (this.dayValue == "5,6") {
          let highDate = validDate.toString().split("GMT")[0];
          if ((this.yesterday.getDate() < date) && (day !== 5 && day !== 6)) {
            this.datesToHighlight.push(highDate);
          }
          return day !== 1 && day !== 2 && day !== 3 && day !== 4 && day !== 0 ? 'example-custom-date-class' : '';
        }
      } else if (this.monthSelected) {

        if (month + 1 == this.monthValue) {
          if (date === this.yesterday.getDate()) {
            // this.datesToHighlight.push(validDate);
            let highDate = validDate.toString().split("GMT")[0];
            this.datesToHighlight.push(highDate);
            return (date === this.yesterday.getDate()) ? 'example-custom-date-class' : '';
          }
        }
      } else {
        return (date === this.yesterday.getDate()) ? 'example-custom-date-class' : '';
      }
    }
    return '';
  }
  constructor(
    public modalCtrl: ModalController,
    private navParams: NavParams,
    public helperService: HelperService,
    public storage: Storage,
    public formBuilder: FormBuilder,
    // private backendService: BackendService,
    private router: Router,) {
    this.schedule = this.navParams.get('Data');
    //console.log(this.schedule);
    // this.yesterday.setDate(this.yesterday.getDate());
  }
  intervalForm: FormGroup = this.formBuilder.group({
    every: ['*', [Validators.required]],
    week: ['*', [Validators.required]],
    everyDate: ['*', [Validators.required]],
    monthValue: ['*', [Validators.required]],
    monthFrom: ['', []],
    monthTo: ['', []],
    everyHour: ['*', [Validators.required]],
    everyHourFrom: ['', []],
    everyHourTo: ['', []],
    everyMinuteFrom: ['', []],
    everyMinuteTo: ['', []],
    everyDateFrom: ['', []],
    everyDateTo: ['', []],
    everyMinute: ['*', [Validators.required]],
    dateType: ['', []],
    hourType: ['', []],
    // selectedMonth: ['', []],

  })
  ngOnInit() {
    // let data = min+" "+hour+" "+date+" "+month+" "+week;
    this.intervalForm = this.formBuilder.group({
      every: ['*', [Validators.required]],
      week: ['', [Validators.required]],
      everyDate: ['', [Validators.required]],
      monthValue: [this.schedule.split(" ")[3], [Validators.required]],
      monthFrom: ['', []],
      monthTo: ['', []],
      everyHour: ['', [Validators.required]],
      everyHourFrom: ['', []],
      everyHourTo: ['', []],
      everyMinuteFrom: ['', []],
      everyMinuteTo: ['', []],
      everyDateFrom: ['', []],
      everyDateTo: ['', []],
      everyMinute: ['', [Validators.required]],
      dateType: ['1', []],
      hourType: ['1', []],
      // selectedMonth: ['', []],
    })
    let arr = [];
    let schedular = this.schedule.split(" ");
    if (this.schedule == "* * * * *") {
      this.isDisabled = false;
      this.cronType = 1;
      this.intervalForm.get('every').setValue(1);
      this.intervalForm.get('everyMinute').setValue(0);
      this.selected1 = this.selected.toString().split("GMT")[0];
    } else if (this.schedule.includes(",")) {
      let schedules = this.schedule.split(" ");
      //Weekly Preset only weekends selection crontype 5
      if (!this.schedule.split(" ")[4].includes("*") && this.schedule.split(" ")[3].includes("*")) {
        this.cronType = 5;
        this.isDisabled = true;
        this.intervalForm.get('every').setValue(5);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        if (this.schedule.split(" ")[2].includes("*")) {
          this.intervalForm.get('everyDate').setValue("*");
        } else {
          this.intervalForm.get('everyDate').setValue(JSON.parse(this.schedule.split(" ")[2]));;
        }
        if (this.schedule.split(" ")[3].includes("*")) {
          this.intervalForm.get('monthValue').setValue("*");
        } else {
          this.intervalForm.get('monthValue').setValue(JSON.parse(this.schedule.split(" ")[3]));
        }
        if (this.schedule.split(" ")[4] == 0) {
          this.dayValue = 1;
        } else {
          if (this.schedule.split(" ")[4].includes(",")) {
            this.dayValue = this.schedule.split(" ")[4]
          } else {
            this.dayValue = JSON.parse(this.schedule.split(" ")[4]) + 1;
          }
        }
        this.intervalForm.get('week').setValue(this.dayValue);
        this.weekSelected = true;
        this.monthSelected = false;
        this.onLoadData();
      }

      //Value list separator 
      if (this.schedule.split(" ")[4].includes("*") && !this.schedule.split(" ")[3].includes("*")) {
        this.cronType = 11;
        this.isDisabled = true;
        this._hourValue = 2;
        this._DateValue = 2;
        this.intervalForm.get('every').setValue(11);
        for (let i = 0; i <= schedules.length - 1; i++) {
          if (i == 0) {
            if (schedules[i].includes(",")) {
              this.intervalForm.get('everyMinuteFrom').setValue(JSON.parse(schedules[i].split(",")[0]));
              this.intervalForm.get('everyMinuteTo').setValue(JSON.parse(schedules[i].split(",")[1]));
            } else {
              this.intervalForm.get('everyMinuteFrom').setValue(0);
              this.intervalForm.get('everyMinuteTo').setValue(0);
            }
          } else if (i == 1) {
            if (schedules[i].includes(",")) {
              this.intervalForm.get('everyHourFrom').setValue(JSON.parse(schedules[i].split(",")[0]));
              this.intervalForm.get('everyHourTo').setValue(JSON.parse(schedules[i].split(",")[1]));
            } else {
              this.intervalForm.get('everyHourFrom').setValue(0);
              this.intervalForm.get('everyHourTo').setValue(0);
            }
          } else if (i == 2) {
            if (schedules[i].includes(",")) {
              this.intervalForm.get('everyDateFrom').setValue(JSON.parse(schedules[i].split(",")[0]));
              this.intervalForm.get('everyDateTo').setValue(JSON.parse(schedules[i].split(",")[1]));
            } else {
              this.intervalForm.get('everyDateFrom').setValue(0);
              this.intervalForm.get('everyDateTo').setValue(0);
            }
          } else if (i == 3) {
            if (schedules[i].includes(",")) {
              this.intervalForm.get('monthFrom').setValue(JSON.parse(schedules[i].split(",")[0]));
              this.intervalForm.get('monthTo').setValue(JSON.parse(schedules[i].split(",")[1]));
            } else {
              this.intervalForm.get('monthFrom').setValue(0);
              this.intervalForm.get('monthTo').setValue(0);
            }
          } else if (i == 4) {
            this.intervalForm.get('week').setValue("*");
          }
        }
      }else if(this.schedule.split(" ")[1].includes("*")){ //Preset minutes & select days and months checkboxes
        this.cronType = 1;
        this.isDisabled = false;
        this.intervalForm.get('every').setValue(1);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.selectedMonthIdList = this.schedule.split(" ")[3].split(",");
        this.selectedDayIdList = this.schedule.split(" ")[4].split(",");
      }else if(!this.schedule.split(" ")[1].includes("*")){ //Preset Hours/Day & select days and months checkboxes
        this.cronType = 2;
        this.isDisabled = false;
        this.intervalForm.get('every').setValue(2);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        this.selectedMonthIdList = this.schedule.split(" ")[3].split(",");
        this.selectedDayIdList = this.schedule.split(" ")[4].split(",");
      }

    } else if (this.schedule.includes("-")) {
      let schedules = this.schedule.split(" ");
      //Weekly Preset only weekday selection crontype 5
      if (!this.schedule.split(" ")[4].includes("*")) {
        this.cronType = 5;
        this.isDisabled = true;
        this.intervalForm.get('every').setValue(5);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        if (this.schedule.split(" ")[2].includes("*")) {
          this.intervalForm.get('everyDate').setValue("*");
        } else {
          this.intervalForm.get('everyDate').setValue(JSON.parse(this.schedule.split(" ")[2]));;
        }
        if (this.schedule.split(" ")[3].includes("*")) {
          this.intervalForm.get('monthValue').setValue("*");
        } else {
          this.intervalForm.get('monthValue').setValue(JSON.parse(this.schedule.split(" ")[3]));
        }
        if (this.schedule.split(" ")[4] == 0) {
          this.dayValue = 1;
        } else {
          if (this.schedule.split(" ")[4].includes("-") || this.schedule.split(" ")[4].includes(",")) {
            this.dayValue = this.schedule.split(" ")[4]
          } else {
            this.dayValue = JSON.parse(this.schedule.split(" ")[4]) + 1;
          }
        }
        this.intervalForm.get('week').setValue(this.dayValue);
        this.weekSelected = true;
        this.monthSelected = false;
        this.onLoadData();
      }

      //Range preset range of values
      if (!this.schedule.split(" ")[2].includes("*")) {
        this.cronType = 3;
        this.isDisabled = true;
        this._hourValue = 2;
        this._DateValue = 2;
        this.intervalForm.get('every').setValue(3);
        for (let i = 0; i <= schedules.length - 1; i++) {
          if (i == 0) {
            if (schedules[i].includes("-")) {
              this._hourValue = 2;
              this.intervalForm.get('everyMinuteFrom').setValue(JSON.parse(schedules[i].split("-")[0]));
              this.intervalForm.get('everyMinuteTo').setValue(JSON.parse(schedules[i].split("-")[1]));
            } else {
              this._hourValue = 1;
              // this.intervalForm.get('everyMinuteFrom').setValue(0);
              this.intervalForm.get('everyMinute').setValue(0);
            }
          } else if (i == 1) {
            if (schedules[i].includes("-")) {
              this._hourValue = 2;
              this.intervalForm.get('everyHourFrom').setValue(JSON.parse(schedules[i].split("-")[0]));
              this.intervalForm.get('everyHourTo').setValue(JSON.parse(schedules[i].split("-")[1]));
            } else {
              this._hourValue = 1;
              this.intervalForm.get('everyHour').setValue(0);
              // this.intervalForm.get('everyHourTo').setValue(0);
            }
          } else if (i == 2) {
            if (schedules[i].includes("-")) {
              this._DateValue = 2;
              this.intervalForm.get('everyDateFrom').setValue(JSON.parse(schedules[i].split("-")[0]));
              this.intervalForm.get('everyDateTo').setValue(JSON.parse(schedules[i].split("-")[1]));
            } else {
              this._DateValue = 1;
              this.dayOfMonthValue = JSON.parse(this.schedule.split(" ")[2]);
              this.intervalForm.get('everyDate').setValue(this.dayOfMonthValue);
            }
          } else if (i == 3) {
            // this.intervalForm.get('month').setValue("*");
          } else if (i == 4) {
            // this.intervalForm.get('week').setValue("*");
          }
        }
      }

    } else if (this.schedule.includes("/")) {
      this.isDisabled = true;
      let schedules = this.schedule.split(" ");
      for (let i = 0; i <= schedules.length - 1; i++) {
        if (i == 0) {
          if (schedules[i].includes("/")) {
            this.intervalForm.get('everyMinute').setValue(JSON.parse(schedules[i].split("/")[1]));
          } else {
            if (schedules[i] != "*") {
              this.intervalForm.get('everyMinute').setValue(JSON.parse(schedules[i]));
            } else {
              this.intervalForm.get('everyMinute').setValue(schedules[i]);
            }
          }
        } else if (i == 1) {
          if (schedules[i].includes("/")) {//At every minute past every hour
            if (this.schedule.split(" ")[4] >= 0) {
              this.cronType = 9;
              this.intervalForm.get('every').setValue(9);
            } else {
              this.cronType = 2;
              this.intervalForm.get('every').setValue(2);
            }
            this.intervalForm.get('everyHour').setValue(JSON.parse(schedules[i].split("/")[1]));
          } else {
            this.intervalForm.get('everyHour').setValue(JSON.parse(schedules[i]));
          }
        } else if (i == 2) {
          if (schedules[i].includes("/")) {
            this.intervalForm.get('everyDate').setValue(JSON.parse(schedules[i].split("/")[1]));
          } else {
            if (schedules[i] != "*") {
              this.intervalForm.get('everyDate').setValue(JSON.parse(schedules[i]));
            } else {
              this.intervalForm.get('everyDate').setValue(schedules[i]);
            }
          }
        } else if (i == 3) {

          if (schedules[i].includes("/")) {//At every 6th month
            this.cronType = 7;
            this.intervalForm.get('every').setValue(7);
            this.intervalForm.get('monthValue').setValue(JSON.parse(schedules[i]).split("/")[1]);
          } else {
            if (schedules[i] != "*") {
              this.intervalForm.get('monthValue').setValue(JSON.parse(schedules[i]));
            } else {
              this.intervalForm.get('monthValue').setValue(schedules[i]);
            }
          }
        } else if (i == 4) {
          if (schedules[i].includes("*")) {
            this.intervalForm.get('week').setValue("*");
          } else {
            if (this.schedule.split(" ")[1].includes("/")) { //At minute 0 past every 5th hour on Sunday.(0 */5 * * 0)
              this.cronType = 9;
              this.intervalForm.get('every').setValue(9);
            } else if (this.schedule.split(" ")[0].includes("/")) {
              this.cronType = 10;
              this.intervalForm.get('every').setValue(10);
            }
            if (schedules[i] == 0) {
              this.dayValue = 1;
            } else {
              this.dayValue = JSON.parse(schedules[i]) + 1;
            }
            this.intervalForm.get('week').setValue(this.dayValue);
          }
        }
      }
    } else if (!schedular.includes("/") || schedular.includes("-") || schedular.includes("-")) {
      //Every Minute Preset (cron type 1)
      if (!this.schedule.split(" ")[0].includes("*") && this.schedule.split(" ")[1] == "*" && this.schedule.split(" ")[2] == "*" && this.schedule.split(" ")[3] == "*" && this.schedule.split(" ")[4] == "*") {
        this.cronType = 1;
        this.isDisabled = false;
        this.intervalForm.get('every').setValue(1);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.selected1 = this.selected.toString().split("GMT")[0];
      }

      //Every Day Preset (cron type 3)
      if ((this.schedule.split(" ")[0].includes("*") || this.schedule.split(" ")[0] >= 0) && !this.schedule.split(" ")[1].includes("*") && this.schedule.split(" ")[2] == "*" && this.schedule.split(" ")[3] == "*" && this.schedule.split(" ")[4] == "*") {
        this.cronType = 4;
        this.isDisabled = false;
        this.intervalForm.get('every').setValue(4);
        if (this.schedule.split(" ")[0].includes("*")) {
          this.intervalForm.get('everyMinute').setValue(0);
        } else {
          this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        }
        this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        this.selected1 = this.selected.toString().split("GMT")[0];
      }

      //Weekly Preset Cron Type 5
      if (!this.schedule.split(" ")[4].includes("*") && !this.schedule.split(" ")[4].includes("-") && !this.schedule.split(" ")[4].includes(",")) {
        this.cronType = 5;
        this.isDisabled = true;
        this.intervalForm.get('every').setValue(5);
        this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        if (this.schedule.split(" ")[2].includes("*")) {
          this.intervalForm.get('everyDate').setValue("*");
        } else {
          this.intervalForm.get('everyDate').setValue(JSON.parse(this.schedule.split(" ")[2]));;
        }
        if (this.schedule.split(" ")[3].includes("*")) {
          this.intervalForm.get('monthValue').setValue("*");
        } else {
          this.intervalForm.get('monthValue').setValue(JSON.parse(this.schedule.split(" ")[3]));
        }
        if (this.schedule.split(" ")[4] == 0) {
          this.dayValue = 1;
        } else {
          this.dayValue = JSON.parse(this.schedule.split(" ")[4]) + 1;
        }
        this.intervalForm.get('week').setValue(this.dayValue);

        this.weekSelected = true;
        this.monthSelected = false;
        this.onLoadData();
      }

      //Monthly Preset Cron Type 6
      if ((this.schedule.split(" ")[0].includes("*") || this.schedule.split(" ")[0] >= 0) && (this.schedule.split(" ")[1].includes("*") || this.schedule.split(" ")[1] >= 0) && !this.schedule.split(" ")[2].includes("*") && this.schedule.split(" ")[3] == "*" && this.schedule.split(" ")[4] == "*") {
        this.cronType = 6;
        this.isDisabled = true;
        this.intervalForm.get('every').setValue(6);
        if (this.schedule.split(" ")[0].includes("*")) {
          this.intervalForm.get('everyMinute').setValue(0);
        } else {
          this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        }
        if (this.schedule.split(" ")[1].includes("*")) {
          this.intervalForm.get('everyHour').setValue(0);
        } else {
          this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        }
        this.intervalForm.get('everyDate').setValue(JSON.parse(this.schedule.split(" ")[2]));
        this.selected1 = this.selected.toString().split("GMT")[0];
        this.weekSelected = false;
        this.monthSelected = true;
        this.onLoadData();
      }

      //Yearly Preset Cron Type 8
      if ((this.schedule.split(" ")[0].includes("*") || this.schedule.split(" ")[0] >= 0) && (this.schedule.split(" ")[1].includes("*") || this.schedule.split(" ")[1] >= 0) && (this.schedule.split(" ")[2] == "*" || this.schedule.split(" ")[2] >= 0) && !this.schedule.split(" ")[3].includes("*") && this.schedule.split(" ")[4] == "*") {
        this.cronType = 8;
        this.isDisabled = true;
        this.intervalForm.get('every').setValue(8);
        this.monthValue = JSON.parse(this.schedule.split(" ")[3]);
        if (this.schedule.split(" ")[0].includes("*")) {
          this.intervalForm.get('everyMinute').setValue(0);
        } else {
          this.intervalForm.get('everyMinute').setValue(JSON.parse(this.schedule.split(" ")[0]));
        }
        if (this.schedule.split(" ")[1].includes("*")) {
          this.intervalForm.get('everyHour').setValue(0);
        } else {
          this.intervalForm.get('everyHour').setValue(JSON.parse(this.schedule.split(" ")[1]));
        }
        if (this.schedule.split(" ")[1].includes("*")) {
          this.intervalForm.get('everyDate').setValue(0);
        } else {
          this.intervalForm.get('everyDate').setValue(JSON.parse(this.schedule.split(" ")[2]));
        }
        this.intervalForm.get('monthValue').setValue(this.monthValue);
        this.selected1 = this.selected.toString().split("GMT")[0];
        this.weekSelected = false;
        this.monthSelected = true;
        this.onLoadData();
      }
    }

  }

  firstSelectDay: any;
  weekSelected = false;
  monthSelected = false;
  changeWeekDay(event: any) {
    this.dayValue = event.value;
    this.weekSelected = true;
    this.monthSelected = false;
    const future = new Date();
    future.setDate(future.getDate());
    this.datesToHighlight = [];
    this.dateClass(future, "month");
    this.calendar.updateTodaysDate();
  }


  changeDate(event, onEvent?) {
    this.weekSelected = false;

    this.datesToHighlight = [];
    this.dayValue = "";
    if (this.cronType != 8) {
      this.monthSelected = false;
      this.monthValue = "";
      this.intervalForm.get('monthValue').setValue("*");
    }
    this.intervalForm.get('week').setValue("*");
    this.dayOfMonthValue = event.value;
    let future = new Date();
    future.setDate(this.dayOfMonthValue);
    let search = future.toString().split(" ")[0];
    // this.dayValues.map((key) => { if (key.value.includes(search)) { this.dayValue = key.id; } });
    this.monthValue = future.getMonth() + 1;
    this.yesterday = future;
    this.dateClass(this.yesterday, 'month')
    this.onSelect(future);
  }

  onSelect(event) {
    this.selected = event;
    if (event._d == undefined) {
      this.selected1 = event.toString().split("GMT")[0];
    } else {
      this.selected1 = event._d;
      this.selected1 = this.selected1.toString().split("GMT")[0];
    }
    this.calendar.updateTodaysDate();
  }
  changeMonth(event, onEvent?) {
    this.dayValue = "";
    this.dayOfMonthValue = "";
    this.intervalForm.get('week').setValue("*");

    this.weekSelected = false;
    this.monthSelected = true;
    this.monthValue = event.value;
    const future = new Date();
    future.setDate(future.getDate());
    this.dateClass(future, "month");
    this.calendar.updateTodaysDate();
  }
  changeHour(event, onEvent?) {

    let newArr = [];
    if (this.cronType == 9) {
      if (this.intervalForm.value.everyHour <= 0) {
        this.intervalForm.get('everyHour').setValue(1);
        // return
        onEvent = "1";
      }
    }
    if (event != undefined && event != "") {
      if (this.weekSelected == true || this.monthSelected == true) {
        for (let item of this.datesToHighlight) {
          if (event.value > 9) {
            item = item.substring(0, 16) + event.value + item.substring(17 + 1);
          } else {
            item = item.substring(0, 16) + "0" + event.value + item.substring(17 + 1);
          }
          newArr.push(item);
        }
      }
    } else {
      if (this.weekSelected == true || this.monthSelected == true) {

        if (onEvent.includes("*/")) {
          //console.log(onEvent);
        } else {
          onEvent = JSON.parse(onEvent);
          for (let item of this.datesToHighlight) {
            if (onEvent > 9) {
              item = item.substring(0, 16) + onEvent + item.substring(17 + 1);
            } else {
              item = item.substring(0, 16) + "0" + onEvent + item.substring(17 + 1);
            }
            newArr.push(item);
          }
        }

      }


    }
    if (this.intervalForm.value.everyHourFrom > 0) {
      if (this.intervalForm.value.everyHourFrom > this.intervalForm.value.everyHourTo) {
        //console.log("To hour should be grater than from hour");
        this.intervalForm.get('everyHourTo').setValue(this.intervalForm.value.everyHourFrom + 1);
      } else {
        //console.log(this.intervalForm.value.everyHourTo);
      }

    }
    this.datesToHighlight = newArr;
    this.hourValue = event.value;

  }
  changeMin(event, onEvent?) {
    let newArr = [];
    if (this.cronType == 10) {
      if (this.intervalForm.value.everyMinute <= 0) {
        this.intervalForm.get('everyMinute').setValue(1);
        // return
        onEvent = "1";
      }
    }
    if (event != undefined && event != "") {
      if (this.weekSelected == true || this.monthSelected == true) {
        for (let item of this.datesToHighlight) {
          if (event.value > 9) {
            item = item.substring(0, 19) + event.value + item.substring(20 + 1);
          } else {
            item = item.substring(0, 19) + "0" + event.value + item.substring(20 + 1);
          }
          newArr.push(item);
        }
      }
    } else {
      if (this.weekSelected == true || this.monthSelected == true) {

        if (onEvent.includes("*/")) {
          //console.log(onEvent);
        } else {
          onEvent = JSON.parse(onEvent);
          // //console.log(onEvent);
          for (let item of this.datesToHighlight) {
            if (onEvent > 9) {
              item = item.substring(0, 19) + onEvent + item.substring(20 + 1);
            } else {
              item = item.substring(0, 19) + "0" + onEvent + item.substring(20 + 1);
            }
            newArr.push(item);
          }
        }

      }
    }
    if (this.intervalForm.value.everyMinuteFrom > 0) {
      if (this.intervalForm.value.everyMinuteTo != 0) {
        if (this.intervalForm.value.everyMinuteTo < this.intervalForm.value.everyMinuteFrom) {
          //console.log("To hour should be grater than from hour");
          this.intervalForm.get('everyMinuteTo').setValue(this.intervalForm.value.everyMinuteFrom + 1);
        }
      }
    }
    this.datesToHighlight = newArr;
    this.minuteValue = event.value;

  }
  presetChange(event) {
    this.cronType = event.value;
    this.isDisabled = true;
    if(this.cronType != 1 && this.cronType != 2 && this.cronType != 4){
      this.selectedDayIdList = [];
      this.selectedMonthIdList = [];
    }    
    if (this.cronType == 1) {
      // this.minuteValue = "";
      this.isDisabled = false;
      this.hourValue = "";
      this.dayValue = "";
      this._DateValue = 1;
      this._hourValue = 1;
      this.dayOfMonthValue = "";
      this.monthValue = "";
      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('everyHour').setValue("*");
      this.intervalForm.get('week').setValue("*");
      this.intervalForm.get('everyDate').setValue("*");
      this.intervalForm.get('monthValue').setValue("*");
    } else if (this.cronType == 2 || this.cronType == 4) {
      // this.minuteValue = "";
      this.isDisabled = false;
      this._DateValue = 1;
      this._hourValue = 1;
      this.hourValue = "";
      this.dayValue = "";
      this.dayOfMonthValue = "";
      this.monthValue = "";
      this.intervalForm.get('everyHour').setValue(0);
      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('week').setValue("*");
      this.intervalForm.get('everyDate').setValue("*");
      this.intervalForm.get('monthValue').setValue("*");

    } else if (this.cronType == 3 || this.cronType == 11) {
      this.hourValue = "";
      this._DateValue = 2;
      this._hourValue = 2;
      this.dayValue = "";
      this.dayOfMonthValue = "";
      this.monthValue = "";
      const future = new Date();
      future.setDate(future.getDate());
      const validDate = new Date(future);
      const date = validDate.getDate();
      const month = validDate.getMonth() + 1;
      this.intervalForm.get('everyHourFrom').setValue(1);
      this.intervalForm.get('everyHourTo').setValue(2);
      this.intervalForm.get('everyMinuteFrom').setValue(0);
      this.intervalForm.get('everyMinuteTo').setValue(5);
      this.intervalForm.get('everyMinute').setValue("*");
      this.intervalForm.get('everyHour').setValue("*");
      this.intervalForm.get('week').setValue("*");
      this.intervalForm.get('everyDateFrom').setValue(date);
      this.intervalForm.get('everyDateTo').setValue(date);
      this.intervalForm.get('monthFrom').setValue(month);
      this.intervalForm.get('monthTo').setValue(month);
      this.intervalForm.get('everyDate').setValue("*");
      this.intervalForm.get('monthValue').setValue("*");
    } else if (this.cronType == 5) {
      this._DateValue = 1;
      this._hourValue = 1;
      this.datesToHighlight = [];
      this.dayValue = 1;
      this.weekSelected = true;
      this.monthSelected = false;
      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('everyHour').setValue(0);
      this.intervalForm.get('week').setValue(1);
      this.intervalForm.get('everyDate').setValue("*");
      this.intervalForm.get('monthValue').setValue("*");
      this.onLoadData();
      this.calendar.updateTodaysDate();
    } else if (this.cronType == 6) {
      this.datesToHighlight = [];
      this._DateValue = 1;
      this._hourValue = 1;
      this.weekSelected = false;
      this.monthSelected = false;
      const future = new Date();
      future.setDate(future.getDate());
      const validDate = new Date(future);
      const date = validDate.getDate();
      this.dayOfMonthValue = date;
      // const month = validDate.getMonth();
      // this.monthValue = month+1;
      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('everyHour').setValue(0);
      this.intervalForm.get('everyDate').setValue(this.dayOfMonthValue);
      this.intervalForm.get('monthValue').setValue("*");
      this.onLoadData();
      this.calendar.updateTodaysDate();
      this.onSelect(future);
    } else if (this.cronType == 7) {
      this.weekSelected = false;
      this.monthSelected = false;
      this._DateValue = 1;
      this._hourValue = 1;
      this.datesToHighlight = [];
      const future = new Date();
      future.setDate(future.getDate());
      const validDate = new Date(future)
      const month = validDate.getMonth();
      this.monthValue = month + 1;
      const date = validDate.getDate();
      this.dayOfMonthValue = date;

      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('everyHour').setValue(0);
      this.intervalForm.get('week').setValue("*");
      this.intervalForm.get('everyDate').setValue(this.dayOfMonthValue);
      this.onLoadData();
      this.calendar.updateTodaysDate();
      this.onSelect(future);
    } else if (this.cronType == 8) {
      this.weekSelected = false;
      this.monthSelected = true;
      this._DateValue = 1;
      this._hourValue = 1;
      this.datesToHighlight = [];
      const future = new Date();
      future.setDate(future.getDate());
      const validDate = new Date(future)
      const month = validDate.getMonth();
      this.monthValue = month + 1;

      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('everyHour').setValue(0);
      const date = validDate.getDate();
      this.dayOfMonthValue = date;
      this.intervalForm.get('everyDate').setValue(this.dayOfMonthValue);
      this.intervalForm.get('monthValue').setValue(this.monthValue);
      this.onLoadData();
      this.calendar.updateTodaysDate();
      this.onSelect(future);
    } else if (this.cronType == 9) {
      this._DateValue = 1;
      this._hourValue = 1;
      this.intervalForm.get('everyHour').setValue(1);
      this.intervalForm.get('everyMinute').setValue(0);
      this.intervalForm.get('week').setValue(1);
      this.intervalForm.get('everyDate').setValue(0);
      this.intervalForm.get('monthValue').setValue(0);
    } else if (this.cronType == 10) {
      this._DateValue = 1;
      this._hourValue = 1;
      this.intervalForm.get('everyHour').setValue(0);
      this.intervalForm.get('everyMinute').setValue(1);
      this.intervalForm.get('week').setValue(1);
      this.intervalForm.get('everyDate').setValue(0);
      this.intervalForm.get('monthValue').setValue(0);
    }
  }
  sixMonth: any = [];
  onLoadData() {
    if (this.weekSelected) {
      const future = new Date();
      future.setDate(future.getDate());
      this.dateClass(future, "month");
    } else if (this.monthSelected) {
      const future = new Date();
      future.setDate(future.getDate());
      this.dateClass(future, "month");
    } else {
      let future = new Date();
      future.setDate(this.dayOfMonthValue);
      let search = future.toString().split(" ")[0];
      this.dayValues.map((key) => { if (key.value.includes(search)) { this.dayValue = key.id; } });
      this.monthValue = future.getMonth() + 1;
      this.yesterday = future;
      // //console.log(this.yesterday);
      // this.selected1 = 
      this.dateClass(this.yesterday, 'month')
    }

    // this.calendar.updateTodaysDate();
  }
  submitInterval() {

    let minFrom = this.intervalForm.value.everyMinuteFrom;
    let minTo = this.intervalForm.value.everyMinuteTo;
    let min = this.intervalForm.value.everyMinute;
    // let mainHour = this.intervalForm.value.everyHour;
    let hour = this.intervalForm.value.everyHour;
    let hourFrom = this.intervalForm.value.everyHourFrom;
    let hourTo = this.intervalForm.value.everyHourTo;
    let dateFrom = this.intervalForm.value.everyDateFrom;
    let dateTo = this.intervalForm.value.everyDateTo;
    let date = this.intervalForm.value.everyDate;
    let month = this.intervalForm.value.monthValue;
    let monthFrom = this.intervalForm.value.monthFrom;
    let monthTo = this.intervalForm.value.monthTo;
    let week = this.intervalForm.value.week;
    if (min == undefined || min == "") {
      min = 0;
    }
    if (this.cronType == 2) {
      if (hour == undefined || hour == "") {
        if ((this.cronType == 1 || hour == 0 || hour == 1) && (this.cronType != 4) && (this.cronType != 5) && (this.cronType != 6) && (this.cronType != 7) && (this.cronType != 8)) {
          hour = "*";
        }
      }
    } else if (this.cronType == 3) {
      if (this._DateValue == 1) {
        date = date;
      } else {
        if ((dateFrom != undefined && dateFrom != "") && (dateTo != undefined && dateTo != "")) {
          date = dateFrom + "-" + dateTo;
        }
      }
      if (this._hourValue == 1) {
        hour = hour;
        min = min;
      } else {
        if ((hourFrom != undefined && hourFrom != "") && (hourTo != undefined && hourTo != "")) {
          hour = hourFrom + "-" + hourTo;
        }
        if (minTo != undefined && minTo != "") {
          min = minFrom + "-" + minTo;
        } else {
          min = 0 + "-" + 0;
        }
      }
    }

    if (date == undefined || date == "") {
      date = "*";
    }

    if (this.cronType == 7) {
      month = "*/6";
    } else {
      if (month == undefined || month == "") {
        month = "*";
      }
    }
    if (week == undefined || week == "") {
      week = "*";
    }
    if (week == "*" || this.cronType == 6) {
      week = "*"
    } else if (isNaN(week) == false) {
      week = week - 1;
    }


    let data;
    if (min != 0 && hour == "*" && date == "*" && month == "*" && week == "*") {
      data = "*/" + min + " " + hour + " " + date + " " + month + " " + week;
    } else if (hour >= 1 && date == "*" && month == "*" && week == "*" && this.cronType != 4) {
      data = min + " " + "*/" + hour + " " + date + " " + month + " " + week;
    } else {
      data = min + " " + hour + " " + date + " " + month + " " + week;
    }

    if (this.cronType == 9) {
      data = min + " " + "*/" + hour + " " + date + " " + month + " " + week;
    } else if (this.cronType == 10) {
      data = "*/" + min + " " + hour + " " + date + " " + month + " " + week;
    } else if (this.cronType == 11) {
      if ((hourFrom != undefined && hourFrom != "") && (hourTo != undefined && hourTo != "")) {
        hour = hourFrom + "," + hourTo;
      }
      if (minFrom != undefined && minFrom != "") {
        if (minTo != undefined && minTo != "") {
          min = minFrom + "," + minTo;
        } else {
          min = minFrom;
        }
      }
      if ((dateFrom != undefined && dateFrom != "") && (dateTo != undefined && dateTo != "")) {
        date = dateFrom + "," + dateTo;
      }
      if ((monthFrom != undefined && monthFrom != "") && (monthTo != undefined && monthTo != "")) {
        month = monthFrom + "," + monthTo;
      }
      data = min + " " + hour + " " + date + " " + month + " " + week;
    }
    if(hour == "" || hour == undefined){
      hour="*";
    }

    if (this.cronType == 1 || this.cronType == 2 || this.cronType == 4) {
      if (this.selectedDayIdList.includes("*")) {
        let i = this.selectedDayIdList.indexOf("*");
        this.selectedDayIdList.splice(i, 1);
      }
      if (this.selectedMonthIdList.includes("*")) {
        let i = this.selectedMonthIdList.indexOf("*");
        this.selectedMonthIdList.splice(i, 1);
      }
      if ((this.selectedMonthIdList != null && this.selectedMonthIdList.length > 0)) {
        //console.log(this.selectedDayIdList.includes("*"));
        if (this.selectedDayIdList == null || this.selectedDayIdList.length == 0) {
          if (this.selectedMonthIdList.length > 0 && this.selectedMonthIdList[0] != "") {
            data = min + " " + hour +" * " + this.selectedMonthIdList + " *";
          } else {
            data = min + " " + hour +" * * *";
          }
        } else if ((this.selectedDayIdList != null && this.selectedDayIdList.length > 0)) {
          if (this.selectedMonthIdList.length > 0 && this.selectedMonthIdList[0] != "") {
            data = min + " " + hour +" * " + this.selectedMonthIdList + " " + this.selectedDayIdList;
          } else {
            data = min + " " + hour + " * * " + this.selectedDayIdList;
          }
        }
      } else if ((this.selectedDayIdList != null && this.selectedDayIdList.length != 0)) {
        if ((this.selectedMonthIdList == null || this.selectedMonthIdList.length == 0)) {
          data = min + " " + hour +" * * " + this.selectedDayIdList;
        } else if ((this.selectedMonthIdList != null && this.selectedMonthIdList.length != 0)) {
          data = min + " " + hour +" * " + this.selectedMonthIdList + " " + this.selectedDayIdList;
        }
      } else {
        data = min + " " + hour +" * * *";
      }
      this.modalCtrl.dismiss(null, data);
    } else {
      this.modalCtrl.dismiss(null, data);
    }
    // this.ionicForm.controls["interval"].setValue(data);
    console.log(data);

  }


  ngAfterViewInit() {
    // this.scrollContainer = this.scrollFrame.nativeElement;
    // this.itemElements.changes.subscribe(_ => this.onItemElementsChanged());    
  }

  closeModal() {
    //console.log(this.intervalForm.value);
    if (this.schedule == "* * * * *") {
      // 1st everyMinute, 2nd hour, date, month, weekday
      this.intervalForm.reset();
      this.modalCtrl.dismiss(null, "* * * * *");
    } else {
      this.modalCtrl.dismiss(null, this.schedule);
    }
    // this.modalCtrl.dismiss();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog"),
      catalogobjtype: await this.storage.get("catalogobjtype"),
      ibid: await this.storage.get("ibid")
    }
    return data;
  }
  selectedMonths: any = [];
  checkBox(id: any) {
    let index = this.selectedMonths.indexOf(id);
    if (index !== -1) {
      this.selectedMonths.splice(index, 1);
    } else {
      this.selectedMonths.push(id);
    }
  }
  selectedDay: any = [];
  checkDayBox(id: any) {
    let index = this.selectedDay.indexOf(id);
    if (index !== -1) {
      this.selectedDay.splice(index, 1);
    } else {
      this.selectedDay.push(id);
    }
  }
  getChecked(id) {
    return this.selectedDayIdList.includes(id);
  }
  onDayChange(id) {
    let index = this.selectedDayIdList.indexOf(id);
    //console.log(index);
    if (index == -1 && id != "*") {
      this.selectedDayIdList.push(id);
    } else {
      this.selectedDayIdList.splice(index, 1);
    }
    //console.log("this.selectdec ", this.selectedDayIdList);
  }
  getMonthChecked(id) {
    return this.selectedMonthIdList.includes(id);
  }
  onMonthChange(id) {
    let index = this.selectedMonthIdList.indexOf(id);
    //console.log(index);
    if (index == -1 && id != "*") {
      this.selectedMonthIdList.push(id);
    } else {
      this.selectedMonthIdList.splice(index, 1);
    }
    //console.log("this.selectdec ", this.selectedMonthIdList);
  }
  ngOnDestroy(): void {
    // if (this.schedule == "* * * * *") {
    //   // 1st everyMinute, 2nd hour, date, month, weekday
    //   this.intervalForm.reset();
    //   this.modalCtrl.dismiss(null, "* * * * *");
    // } else {
    //   this.modalCtrl.dismiss(null, this.schedule);
    // }
  }

  changeDateType(evt) {
    // console.log(evt.value);
    this._DateValue = evt.value
  }
  changeHourType(evt) {
    // console.log(evt.value);
    this._hourValue = evt.value;
  }
  // set DateValue(val: any) {
  //   this.DateValue = val;
  // }
  // get DateValue() {
  //   return this._DateValue;
  // }
  // set hourRangeValue(val: any) {
  //   this.hourRangeValue = val;
  // }
  // get hourRangeValue() {
  //   return this._hourValue;
  // }
}